module.exports = __webpack_public_path__ + "static/media/Soleil-Bold.df1b55ce.otf";